import React from 'react';
import { Divider, LinkList } from '../../index';
import { ProxyListItem } from "../index";
import "./proxy_list.scss";

export const ProxyList = (props) => {
    const {
        className,
        disabled = false,
        list,
        patients,
        myProxies,
        picker,
        typographyType,
        currentUser,
        primaryUser,
        isShowAllUsers,
        showBadge = false,
        isMobile,
    } = props;
    //console.info(`Proxies picker, patients, props`, picker, patients, props);
    return (
        <LinkList
            className={`mybswh-proxy-list ${className ? className : ''}`}
            disabled={disabled}
            typographyType={typographyType}
        >
            {list.length > 0 &&
                list.map((item, index, ary) => {
                    let pickerCollection = {};
                    if (index < (ary.length - 1)) {
                        let patient = patients[index];
                        //if(item.ei !== patient.patientIds)
                        if (patient && picker.name) {
                            pickerCollection = patient[picker.name];
                        }
                        item.disabled = picker.disabled ? picker.disabled(patient) : item.disabled;
                    }

                    return (<React.Fragment key={index}>
                        <ProxyListItem
                            picker={picker}
                            currentUser={currentUser}
                            primaryUser={primaryUser}
                            disabled={disabled}
                            item={item}
                            pickerCollection={pickerCollection}
                            typographyType={typographyType}
                            isShowAllUsers={isShowAllUsers}
                            showBadge={showBadge}
                        />
                        {index !== (list.length - 1) && <Divider mTop="xsmall" mBottom="xsmall" mHorizontal="none" />}
                        {(props.fromNoProxy && !isMobile) && <Divider mTop="xsmall" mBottom="large" mHorizontal="none" />}
                    </React.Fragment>)
                })
            }
        </LinkList>
    );
};